import React from 'react';
import { useIsMobile } from '../hooks/responsive';

export const DesktopOnly: React.FC = props => {
  const { isMobile } = useIsMobile();

  return isMobile ? null : <>{props.children}</>;
};
